/**
 * Get all excise duty reports: original / manual
 * For: excise duty reports > reports > table
 */

import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

interface IGetAllReports {
  toggleReportType: "original" | "manual";
}
const getAllReports = async ({ toggleReportType }: IGetAllReports) => {
  const token = getToken();
  if (token) {
    const reportURL =
      toggleReportType === "manual" ? "manual_tax_reports" : "tax_reports";
    try {
      const response = await fetch(`${BASE_URL}/api/${reportURL}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data[reportURL];
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token or not admin
  }
};

export default getAllReports;
